import React, {useEffect} from 'react';
import * as Yup from 'yup';
import {useTranslation} from 'react-i18next';
import {GreenButton, LabelField, WhiteButton} from '@styled';
import {Modal, Row, Col} from 'react-bootstrap';
import {Form, Input, MaskedInput, MainLoader} from '@components';
import {PHONE_DIAL_CODE} from '@app/utils/constants';
import {useDispatch, useSelector} from 'react-redux';
import {sagaActions} from './redux/saga';
import {resetFormSubmitSuccess} from './redux/index';

const AddReporterModal = ({show, toggleModal}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const loadedEntity = useSelector((state) => state.entity.loadedEntity);
  const {formSubmitSuccess, formLoading, formError} = useSelector(
    (state) => state.entity.reporters
  );

  const handleSubmit = (values) => {
    dispatch({
      type: sagaActions.SEND_REPORTER_INVITE,
      payload: {entityId: loadedEntity.id, values},
    });
  };

  useEffect(() => {
    if (formSubmitSuccess) {
      dispatch(
        resetFormSubmitSuccess({formName: 'reporter', flagValue: false})
      );
      toggleModal(false);
    }
  }, [formSubmitSuccess]);

  return (
    <Modal
      show={show}
      onHide={() => toggleModal(false)}
      centered
      scrollable
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <h6>Add/Invite Data Reporter</h6>
      </Modal.Header>
      <Modal.Body>
        {formLoading && (
          <MainLoader
            minHeight="100vh"
            spinnerColor="#479541"
            background="rgba(0,0,0,0.2)"
          />
        )}
        <Form
          initialValues={{
            reporterName: '',
            reporterEmail: '',
            reporterPhone: '',
          }}
          validationSchema={Yup.object({
            reporterName: Yup.string().required(
              t('reporter.entity.invites.required.reporterName')
            ),
            reporterEmail: Yup.string()
              .required(t('reporter.entity.invites.required.reporterEmail'))
              .email(
                t('reporter.entity.invites.required.invalidReporterEmail')
              ),
            reporterPhone: Yup.string()
              .required(
                t('reporter.entity.invites.required.reporterPhoneNumber')
              )
              .test({
                name: 'is-valid-phone',
                message: t(
                  'reporter.entity.invites.required.invalidReporterPhone'
                ),
                test: (value) => {
                  let valid = value && value.indexOf('_') === -1;
                  if (valid) {
                    valid = Number(value) > 0;
                  }
                  return valid;
                },
              }),
          })}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {formError && typeof formError === 'string' ? (
            <Row className="mt-3">
              <Col>
                <div className="alert alert-danger">{formError}</div>
              </Col>
            </Row>
          ) : null}
          <Row className="mb-2">
            <Col xs={12} lg={12}>
              <Input
                type="text"
                name="reporterName"
                id="ReporterName"
                label={t('reporter.entity.invites.reporterName')}
                placeholder=""
                required
              />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} lg={12}>
              <Input
                type="email"
                name="reporterEmail"
                id="ReporterEmail"
                label={t('reporter.entity.invites.reporterEmail')}
                placeholder=""
                required
              />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} lg={12}>
              <Row noGutters>
                <Col xs={3} lg={2} className="text-right mt-4">
                  <LabelField className="mb-1 mt-1 mr-2 text-nowrap">
                    {PHONE_DIAL_CODE}
                  </LabelField>
                </Col>
                <Col xs={9} lg={10}>
                  <MaskedInput
                    mask="999999999"
                    name="reporterPhone"
                    id="ReporterPhoneNumber"
                    label={t('reporter.entity.invites.reporterPhoneNumber')}
                    placeholder=""
                    required
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <GreenButton type="submit" className="px-5">
                {t('reporter.entity.invites.submitBtnLabel')}
              </GreenButton>
              <WhiteButton
                type="button"
                className="ml-1"
                onClick={() => {
                  toggleModal(false);
                }}
              >
                {t('reporter.entity.invites.cancelBtnLabel')}
              </WhiteButton>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const AddReporter = () => {
  //   const [t] = useTranslation();
  const [showReporterModal, toggleReporterModal] = React.useState(false);
  const handleAddReporter = () => {
    toggleReporterModal(true);
  };

  return (
    <>
      <GreenButton className="ml-1" onClick={handleAddReporter}>
        <i className="fa fa-plus mr-1" />
        Add/Invite Reporter
      </GreenButton>
      <AddReporterModal
        show={showReporterModal}
        toggleModal={toggleReporterModal}
      />
    </>
  );
};

export default AddReporter;
